// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__NiWS5","icon":"SortAdornment_icon__23ED-","up":"SortAdornment_up__1Z-Qb","down":"SortAdornment_down__13DI3","active":"SortAdornment_active__1pWt8"};